import React, { useEffect } from 'react';
import { BaseConfig } from '../BaseConfig';
import { UIProperties } from '../UIProperties';

// var timeout: any = null;

const ArtifitialProgressUI = (props: UIProperties<ArtifitialProgressUIConfig>) => {
	// if(!timeout) {
	// 	timeout = setTimeout(() => {
	// 		timeout = null;
	// 	}, 5000);
	// }
	
	useEffect(() => {
		(props.parameters as any).onForceUpdate = () => {
			if(props.parameters.isDone) {
				//todo: fade
			}
		}
	})
	return (
		<div className='modal-bg modal-disable-select' style={{
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%',
			pointerEvents: 'all',
			zIndex: 10000
		}}>
			<div style={{
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				width: '680px',
				height: '520px'
			}}>
				<img style={{
					width: '100%',
					height: '70px'
				}} src="./assets/images/SBAR/header_modal_1.png"/>
				<div style={{
					position: 'absolute',
					top: '01px',
					left: '3px',
					width: '680px',
					height: '65px',
				}}>
					<p style={{
						margin: '0px',
						fontSize: '20pt',
						textAlign: 'center',
						position: 'relative',
						top: '18px',
						overflow: 'hidden',
						height: '32px'
					}} tabIndex={0}  id="artifitial-progress-root" className="title-font">{props.parameters.title}</p>
				</div>
				<div style={{
					width: '100%',
					height: '450px',
					position: 'absolute',
					top: '70px',
					left: '0'
				}}>
					<img style={{
						width: '100%',
						height: '100%'
					}} src="./assets/images/SBAR/window_modal_1_edited.png"/>

					<img className='spinner' style={{
						width: '300px',
						position: 'absolute',
						top: '50px',
						left: '190px'
					}} src="./assets/images/artifitial-progress/progress_arrows.png"/>
				</div>
				
			</div>
		</div>
	);

};

export interface ArtifitialProgressUIConfig extends BaseConfig{
	title: string;
	isDone: boolean;
}

export default ArtifitialProgressUI;